import ExcelJS from 'exceljs';
import {
    saveAs
} from 'file-saver';
// 计算文本宽度
function getTextWidth(text, font = '11pt 宋体') {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

// 自动调整列宽
function autoFitColumns(worksheet, data) {
    // 计算每列的最大宽度
    const colWidths = [];

    data.forEach(row => {
        row.forEach((cell, colIndex) => {
            const cellText = String(cell || '');
            const cellWidth = getTextWidth(cellText);

            if (!colWidths[colIndex] || cellWidth > colWidths[colIndex]) {
                colWidths[colIndex] = cellWidth;
            }
        });
    });

    // 设置列宽（加上一些边距）
    colWidths.forEach((width, colIndex) => {
        const col = worksheet.getColumn(colIndex + 1);
        // 将像素宽度转换为 Excel 列宽单位
        const excelWidth = Math.min(Math.max((width + 20) / 7, 8), 50);
        col.width = excelWidth;
    });
}
export async function exportExcelWithImages(data, images, fileName = 'export.xlsx') {
    // 创建工作簿
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    autoFitColumns(worksheet, data);
    // 添加数据
    data.forEach((row, rowIndex) => {
        const worksheetRow = worksheet.addRow(row);

        // 设置行高（为图片留出空间）
        if (images.some(img => img.row === rowIndex)) {
            worksheetRow.height = 80;
        }
    });

    // 添加图片
    for (const image of images) {
        try {
            // 加载图片
            const response = await fetch(image.url);
            const arrayBuffer = await response.arrayBuffer();

            // 添加图片到工作表
            const img = workbook.addImage({
                buffer: arrayBuffer,
                extension: image.extension || 'png',
            });

            worksheet.addImage(img, {
                tl: {
                    col: image.col,
                    row: image.row
                },
                br: {
                    col: image.col + 1,
                    row: image.row + 1
                },
                editAs: 'oneCell'
            });

            // 调整列宽以适应图片
            worksheet.getColumn(image.col + 1).width = 15;

        } catch (error) {
            console.warn(`图片加载失败: ${image.url}`, error);
        }
    }
    // 关键步骤：锁定首行（冻结窗格）
    worksheet.views = [{
            state: 'frozen',
            xSplit: 0,
            ySplit: 1
        } // 冻结首行 (ySplit: 1)
    ];
    // 导出文件
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), fileName);
}